import { Participant } from "@local-types/participant/tableRow";
import { API_BASE_URL } from "./config";

export const fetchParticipants = async (): Promise<Participant[]> => {
  const response = await fetch(`${API_BASE_URL}/participants`);
  if (!response.ok) {
    throw new Error("Ошибка загрузки участников");
  }
  return response.json();
};

export const createParticipant = async (name: string): Promise<Participant> => {
  const response = await fetch(`${API_BASE_URL}/participants`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ name }),
  });

  if (!response.ok) {
    throw new Error("Ошибка создания участника");
  }

  return response.json();
};

export const updateParticipant = async (
  id: number,
  updates: { name?: string },
): Promise<Participant> => {
  const response = await fetch(`${API_BASE_URL}/participants/${id}`, {
    method: "PUT",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(updates),
  });

  if (!response.ok) {
    throw new Error("Ошибка обновления участника");
  }

  return response.json();
};

export const deleteParticipant = async (id: number): Promise<void> => {
  const response = await fetch(`${API_BASE_URL}/participants/${id}`, {
    method: "DELETE",
  });

  if (!response.ok) {
    throw new Error("Ошибка удаления участника");
  }
};
